import { ReactNode } from 'react';
import styled from 'styled-components';

const InvisibleButton = styled.button`
	width: 100%;
	text-align: left;
	background-color: transparent;
	border: 0;
	padding: 0;
`;

export default InvisibleButton;

interface IOptionalInvisibleButtonProps {
	onClick?: () => void;
	children: ReactNode;
}

export const OptionalInvisibleButton = ({ onClick, children }: IOptionalInvisibleButtonProps) => {
	if (onClick != null) {
		return (
			<InvisibleButton type="button" onClick={onClick}>
				{children}
			</InvisibleButton>
		);
	}
	return <>{children}</>;
};
